import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ErrorStore, ErrorStoreStatusEnum } from '@sleipai/sleip-models';
import { StripePriceProductActions } from '../actions/stripe-price-product.actions';
import { StripePriceProductService } from '../services/stripe-price-product.service';

@Injectable()
export class StripePriceProductEffects {
  loadStripePriceProducts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StripePriceProductActions.loadStripePriceProducts),
      switchMap(() =>
        this.stripePriceProductService.loadActiveStripePriceProductsList().pipe(
          map((stripePriceProducts) =>
            StripePriceProductActions.loadStripePriceProductsSuccess({
              stripePriceProducts,
            })
          ),
          catchError(({ message, code }) => {
            const firebaseErrorCode = code as string;
            const error: ErrorStore = {
              message: message,
              status:
                firebaseErrorCode?.replace('functions/', '') ??
                ErrorStoreStatusEnum.INTERNAL,
            };
            return of(
              StripePriceProductActions.loadStripePriceProductsFailure({
                error,
              })
            );
          })
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private stripePriceProductService: StripePriceProductService
  ) {}
}
